import { render, staticRenderFns } from "./SalesInfo.vue?vue&type=template&id=753355f2&"
import script from "./SalesInfo.vue?vue&type=script&lang=ts&"
export * from "./SalesInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports